import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./pricingCard.html";
/**
 * Presentational pricing-plan card. All props are pre-formatted by the
 * caller; no store subscriptions, i18n lookups, or data derivation here.
 */
class PricingCard extends LightningElement {
  constructor(...args) {
    super(...args);
    this.planName = '';
    this.formattedPrice = '';
    this.unitFrequencyLabel = '';
    this.showLowestStartingPriceBadge = false;
    this.lowestStartingPriceLabel = '';
    this.trialPeriodLabel = '';
    this.centered = false;
  }
  get hasPlanName() {
    return Boolean(this.planName);
  }
  get hasUnitFrequencyLabel() {
    return Boolean(this.unitFrequencyLabel);
  }
  get hasTrialPeriodLabel() {
    return Boolean(this.trialPeriodLabel);
  }

  /** Header row is only meaningful when it has a plan name or badge to show; keeps the free-model card from reserving empty header space. */
  get hasHeaderContent() {
    return this.hasPlanName || this.showLowestStartingPriceBadge;
  }
  get cardClass() {
    return this.centered ? 'pricing-card pricing-card--centered' : 'pricing-card';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(PricingCard, {
  publicProps: {
    planName: {
      config: 0
    },
    formattedPrice: {
      config: 0
    },
    unitFrequencyLabel: {
      config: 0
    },
    showLowestStartingPriceBadge: {
      config: 0
    },
    lowestStartingPriceLabel: {
      config: 0
    },
    trialPeriodLabel: {
      config: 0
    },
    centered: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(PricingCard, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;